import { useState, useEffect } from 'react';

import { useContextValue } from "../../context/context";
import TimeCounter from "../TimeCounter/TimeCounter";
import { ClockIcon } from "../../assets/icons/clock";

import "./style.css";

const PickTime = () => {
	const [fromTime, setFromTime] = useState({ hour: 0, minets: 0 });
	const [toTime, setToTime] = useState({ hour: 0, minets: 0 });

	const { setSelectedTime } = useContextValue();

	useEffect(() => {
		setSelectedTime((prev) => ({
			...prev,
			from: fromTime,
			to: toTime,
		}));
	}, [fromTime, toTime, setSelectedTime]);

	return (
		<div className="pick-time">
			<div className="pick-time content">
				<ClockIcon />
				<p>Zeitraum</p>
			</div>
			<div className="pick-time counter">
				<TimeCounter
					fromTo="Von"
					time={fromTime}
					setTime={setFromTime}
				/>
				<TimeCounter
					fromTo="Bis"
					time={toTime}
					setTime={setToTime}
				/>
			</div>
		</div>
	);
};

export default PickTime;
